const routeConfig = {
  "/login": "Login",
  "/forgot-password": "Forgot Password",
  "/reset-password": "Reset Password",
  "/request-access": "Request Access",
  "/user/profile": "Profile",

  "/dashboard": "Dashboard",
  "/notifications": "Notifications",

  // Call Center
  "/call-center/dispatch-entry": "Dispatch Entry",
  "/call-center/edit-dispatch-entry/:id": "Edit Dispatch Entry",
  "/call-center/troublecallentry": "Trouble Call Entry",
  "/call-center/timeticket-entry-and-edit": "Time Ticket Entry and Edit",
  "/call-center/edit-troublecallentry/:id": "Edit Trouble Call Entry",
  "/call-center/AdvancedCallCenterDashboard": "Call Center",
  "/call-center/callcenterlist": "Call Center List",
  "/call-center/edit-callcenterlist/:id": "Edit Call Center List",
  "/call-center/history": "History",
  "/call-center/edit-history/:callNumber": "Edit History",
  "/call-center/employeelog": "Employee Log",
  "/call-center/dispatchhours": "Dispatch Hours & Building Review",
  "/call-center/action-items": "Action Items",
  "/call-center/survey-request-entry": "Survey Request Entry",
  "/call-center/dispatch-hours": "Dispatch Hours Building Review",

  // Maintenance
  "/maintenance/routesummary": "Route Summary",
  "/maintenance/maintenanceContractsList": "Maintenance Contracts List",
  "/maintenance/maintenance-dashboard": "Maintenance Contracts Dashboard",
  "/maintenance/parent-contract-setup": "Parent Contract Set Up",
  "/maintenance/invoicing-email-setup": "Invoicing Email Set Up",
  "/maintenance/maintenance-route-planning": "Maintenance Route Planning",
  "/maintenance/routeanalysis": "Route Analysis",
  "/maintenance/schedule-maintenance": "Scheduled Maintenance",
  "/maintenance/maintenance-contract-entry": "Maintenance Contract Entry",

  // Inspections & Violations
  "/inspections-violations/violations-lists": "Violations List",
  "/inspections-violations/inspections-list": "Inspections List",
  "/inspections-violations/inspections-list-map-view": "Inspections Map View",
  "/inspections-violations/inspections-devices-list":
    "Inspections Devices List",
  "/inspections-violations/tests-due": "Tests Due",
  "/inspections-violations/dobnowconnect": "DOB Now Connect",
  "/inspections-violations/dob-violation-tracking": "DOB Violation Tracking",
  "/inspections-violations/violations-entry": "Violations Entry",
  "/inspections-violations/inspections-entry": "Inspections Entry",
  "/inspections-violations/inspections-email-notifications":
    "Inspections Emailer",
  "/inspections-violations/agency": "Agencies List",
  "/inspections-violations/service-companies": "Service Companies List",
  "/inspections-violations/account-pricing": "Account Pricing List",
  "/inspections-violations/device-defects/:deviceID": "DOB Device",
  "/inspections-violations/group-number-devices/:groupNumber":
    "DOB Device Group",
  "/inspections-violations/create-elv3": "Create ELV3",

  "/setup/managementcompanies": "Management Companies",
  "/setup/devicelist": "Devices",
  "/setup/customerlist": "Customer List",
  "/setup/edit-customerlist/:id": "Edit Customer List",
  "/setup/buildinglist": "Building List",
  "/setup/employeelist": "Employee List",
  "/setup/buildings": "Buildings",
  "/setup/customers": "Customers",
  "/setup/employees": "Employees",
  "/setup/company-defaults": "Company Defaults",
  "/setup/edit-employeelist/:id": "Edit Employee List",
  "/setup/managementcompanies": "Management Companies",
  "/setup/devicelist": "Devices",
  "/setup/deviceentry": "Device Entry",
  "/setup/device-type-editing/:buildingId": "Device Type Editing",
  "/setup/dataonboarding": "Data Onboarding",
  "/setup/rolodex": "Rolodex",
  "/setup/salesperson": "Salesperson",
  "/setup/paymentterms": "Payment Terms",
  "/setup/taxdetails": "Tax Details",

  // Invoicing
  "/invoicing/invoice-list": "Invoice List",
  "/invoicing/invoice-wizard": "Invoice Wizard",
  "/invoicing/invoice-entry-page": "Invoice Entry",
  "/invoicing/invoice-finance-charges": "Invoice Finance Charges",

  // Proposals & Jobs
  "/proposals-and-jobs/proposals-and-jobs-list": "Proposals & Jobs Dashboard",
  "/proposals-and-jobs/proposal-wizard": "Proposal Wizard",

  // Reports
  "/reports/route-mapper": "Route Mapper",

  // Admin
  "/user-security": "Admin",

  // Customer

  "/customer": "Customer Dashboard",
  "/proposals/approval-page": "Proposals Approval",
};

export default routeConfig;
